import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Container } from '@/atoms';
import { Breadcrumbs } from '@/organisms/breadcrumbs/Breadcrumbs';

import { getBreadcrumbsByUrl } from '@/lib/utils';

import type { BreadCrumbs } from '@/lib/utils';
import type { FunctionComponent } from 'react';

/**
 * BreadCrumbsTemplate
 */
const BreadCrumbsTemplate: FunctionComponent = ({ id, className }: any) => {
  const router = useRouter();

  const [breadcrumbs, setBreadcrumbs] = useState<BreadCrumbs>([]);

  useEffect(() => {
    if (router && router.isReady && router.asPath) {
      setBreadcrumbs(getBreadcrumbsByUrl(router.asPath));
    }
  }, [router]);

  return (
    <Container id={id} padding="px-4" wrapper {...(className && { className })}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </Container>
  );
};

BreadCrumbsTemplate.displayName = 'BreadCrumbsTemplate';

export default BreadCrumbsTemplate;
